import CompanyProfile from './company-profile-container';

export default CompanyProfile;
